import { NavLink, Outlet, useNavigate } from 'react-router';
import { BRAND } from '@br/protocol';
import { useLogout } from '../api/queries';
import { useAuth } from '../auth/AuthContext';
import { ROLE_LABEL } from '../lib/labels';
import { cx } from './ui';

const NAV = [
  { to: '/profiles', label: '프로필' },
  { to: '/nodes', label: '노드' },
  { to: '/admin/users', label: '사용자', adminOnly: true },
  { to: '/settings', label: '설정' },
];

/** Operator shell: top navigation + page outlet. */
export function OperatorLayout() {
  const { user, org, isAdmin } = useAuth();
  const logout = useLogout();
  const navigate = useNavigate();
  return (
    <div className="flex min-h-full flex-col">
      <header className="sticky top-0 z-40 border-b border-line bg-surface">
        <div className="mx-auto flex h-14 max-w-6xl items-center gap-6 px-4">
          <NavLink to="/profiles" className="text-base font-bold tracking-tight text-ink">
            {BRAND.name}
          </NavLink>
          <nav className="flex items-center gap-1">
            {NAV.filter((n) => !n.adminOnly || isAdmin).map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  cx(
                    'rounded-md px-3 py-1.5 text-sm font-medium',
                    isActive ? 'bg-primary-soft text-primary-strong' : 'text-ink hover:bg-black/5',
                  )
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-3 text-sm">
            <span className="hidden text-ink-muted sm:inline">{org.name}</span>
            <span className="text-ink">
              {user.name}
              <span className="ml-1 text-xs text-ink-muted">({ROLE_LABEL[user.role]})</span>
            </span>
            <button
              type="button"
              className="rounded-md px-2 py-1 text-ink-muted hover:bg-black/5 hover:text-ink"
              onClick={() => logout.mutate(undefined, { onSettled: () => navigate('/login') })}
            >
              로그아웃
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
